<template>
  <div v-once></div>
</template>

<script>
import { pleaseWait } from 'please-wait'
import 'please-wait/build/please-wait.css'

export default {
  props: ['isLoading'],
  watch: {
    isLoading: {
      handler(isLoading) {
        if (isLoading) {
          this.open()
        } else {
          this.close()
        }
      },
      immediate: true,
    }
  },
  methods: {


    open() {


      if (!this.pleaseWaitInstance) {

        let bnc = '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',

          msg = 'object' == typeof this.isLoading ? this.isLoading : ['to może chwilę zająć..',  'jedną chwilę..', '.. albo dwie..',  'już prawie gotowe..', 'przygotowuję ofertę..', 'dosłownie jeszcze chwila..'],
          first, rest,
          m = [];


        this.pleaseWaitInstance = pleaseWait({
          logo: 'static/logo-white.svg',// 'https://pathgather.github.io/please-wait/assets/images/pathgather.png',


          backgroundColor: '#00605c', //'#007666',
   //       loadingHtml: '<p class="loading-message">Przetwarzanie..</p>',
          loadingHtml: '<p>proszę czekać..</p>' + bnc


        });

        let update = () => {

          if (!this.pleaseWaitInstance){
            return;
          }

          !m.length && ( m = [...msg] );


          [first, ...rest] = m;

          this.pleaseWaitInstance.updateLoadingHtml('<p>' + first + '</p> ' + bnc);

          m = rest;

          // 5 sec + random between .5 to 1.6 sec
          setTimeout(update, 8000 + Math.floor(Math.random()*(1600-500+1)+500) );
        }


        setTimeout(update, 8000);

      }
    },

    
    close() {
      if (this.pleaseWaitInstance != null) {
        this.pleaseWaitInstance.finish()
        this.pleaseWaitInstance = null
      }
    }
  }
}
</script>

<style>
.loading-message {
  color: white;
}



.spinner {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #fff;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}


.pg-loading-html p {

  color: #fff;
  font-size:1.4rem;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}


.pg-loading-logo {
  width:10% !important;
}



@media (max-width: 680px) {

  .pg-loading-logo {

    width:30%;

    max-width: 300px;
    max-height:120px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Loader.vue